import React from 'react'
import BlogPageTemplate from './../templates/BlogPageTemplate/BlogPageTemplate'
export default function BlogPage() {
    return (
        <>
            <BlogPageTemplate />
        </>
    )
}
